import cn from './index.module.css'
import { declOfNum } from '@/helpers/declOfNum'
import FieldWrapper from '@pages/Admin/CourseSettings/components/FieldWrapper/FieldWrapper'
import { normalizeTariffValue } from '../SelectTariffValue/SelectTariffValue'

export type TariffPeriodUnit = 'month' | 'day' | null | undefined

const ShowTariffValue = ({
  tariff,
  value,
  periodUnit,
}: {
  tariff: ICourseTariff
  value: number
  periodUnit?: TariffPeriodUnit
}) => {
  const safeValue = normalizeTariffValue(tariff, value)

  const getPeriodString = (): string => {
    switch (tariff?.type) {
      case 'hour':
        return `${safeValue} ${declOfNum(safeValue, ['час', 'часа', 'часов'])}`
      case 'group_per_lesson':
        return `${safeValue} ${declOfNum(safeValue, ['занятие', 'занятия', 'занятий'])}`
      case 'minute':
        return `${safeValue} ${declOfNum(safeValue, ['минута', 'минуты', 'минут'])}`
      case 'month':
        if (periodUnit === 'day') {
          return `${safeValue} ${declOfNum(safeValue, ['день', 'дня', 'дней'])}`
        }

        return `${safeValue} ${declOfNum(safeValue, ['месяц', 'месяца', 'месяцев'])}`
      case 'stream_custom_period':
      case 'stream_custom_days':
      case 'stream_custom_weeks':
        if (periodUnit === 'day') {
          return `${safeValue} ${declOfNum(safeValue, ['день', 'дня', 'дней'])}`
        }
        if (periodUnit === 'month') {
          return `${safeValue} ${declOfNum(safeValue, [
            'месяц',
            'месяца',
            'месяцев',
          ])}`
        }
        if (tariff?.type === 'stream_custom_days') {
          return `${safeValue} ${declOfNum(safeValue, ['день', 'дня', 'дней'])}`
        }
        if (tariff?.type === 'stream_custom_weeks') {
          return `${safeValue} ${declOfNum(safeValue, [
            'неделя',
            'недели',
            'недель',
          ])}`
        }
        return `${safeValue} ${declOfNum(safeValue, [
          'месяц',
          'месяца',
          'месяцев',
        ])}`

      default:
        return ''
    }
  }

  return (
    <div className={cn.wrapper}>
      <FieldWrapper label="Длительность">
        <div className={cn.valueWrapper}>{getPeriodString()}</div>
      </FieldWrapper>
    </div>
  )
}

export default ShowTariffValue
